import { render } from "./BaseContainer.vue?vue&type=template&id=3826be67&scoped=true"
const script = {}

import "./BaseContainer.vue?vue&type=style&index=0&id=3826be67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3826be67"]])

export default __exports__